/* Saber Legacy — la hoja depende del sistema.
 *
 * Regla de negocio:
 *   Baselit (Knight, Master) -> Midgrade y Heavygrade. Heavygrade suma +$220.
 *   Neopixel (Xenopixel V3)  -> solo Neoblade, sin costo extra.
 *
 * Esto NO toca el selector de variantes de Impulse: la ficha de producto usa
 * el configurador propio (sections/saber-buybox.liquid), cuyos botones son
 *   <button class="sl-card|sl-pill" data-sl-opt="N" data-sl-val="VALOR" aria-pressed="...">
 *
 * Hace tres cosas:
 *   1. Esconde las hojas que no aplican al sistema elegido.
 *   2. Si la hoja que estaba puesta deja de aplicar, hace clic en la válida.
 *      Se usa .click() a propósito, para que el configurador recalcule precio
 *      y variante con su propia lógica en vez de que nosotros la dupliquemos.
 *   3. Con neopixel, la Neoblade dice "Incluido". El configurador calcula ese
 *      importe contra la variante más barata del producto, que es Knight, así
 *      que sin esto diría "+$1,900" aun cuando ya pagaste el Xenopixel.
 *
 * Por qué hace falta: desde que las variantes Xenopixel+Midgrade y
 * Xenopixel+Heavygrade dejaron de existir, elegir Xenopixel dejaba puesta una
 * hoja sin variante. El configurador no lo corregía solo: mostraba un total
 * equivocado y deshabilitaba "Agregar al carrito".
 */
(function () {
  'use strict';

  var HOJAS = { midgrade: 1, heavygrade: 1, neoblade: 1 };
  var SISTEMAS = /knight|master|xenopixel/i;
  var MARCA_NEO = 'xenopixel';

  var ocupado = false;

  function limpio(t) {
    return (t || '').trim().toLowerCase();
  }

  function esNeopixel(valor) {
    return limpio(valor).indexOf(MARCA_NEO) !== -1;
  }

  function estilos() {
    if (document.getElementById('sl-hojas-estilo')) return;
    var s = document.createElement('style');
    s.id = 'sl-hojas-estilo';
    s.textContent = '.sl-hoja-off{display:none !important}';
    document.head.appendChild(s);
  }

  function cajas() {
    var lista = document.querySelectorAll('.sl-box');
    return lista.length ? lista : [document];
  }

  function botonesHoja(caja) {
    return Array.prototype.filter.call(
      caja.querySelectorAll('[data-sl-opt][data-sl-val]'),
      function (b) {
        return HOJAS[limpio(b.getAttribute('data-sl-val'))];
      }
    );
  }

  function sistemaElegido(caja) {
    var b = Array.prototype.filter.call(
      caja.querySelectorAll('[data-sl-opt][data-sl-val][aria-pressed="true"]'),
      function (x) {
        return SISTEMAS.test(x.getAttribute('data-sl-val') || '');
      }
    )[0];
    return b ? b.getAttribute('data-sl-val') : '';
  }

  /* "Incluido" mientras el sistema sea neopixel; el texto original se guarda
     para poder devolverlo si el cliente regresa a Knight o Master. */
  function importe(boton, neo) {
    var d = boton.querySelector('[data-sl-delta]');
    if (!d) return;
    if (neo) {
      if (d.getAttribute('data-sl-orig') === null) {
        d.setAttribute('data-sl-orig', d.textContent);
        d.setAttribute('data-sl-origup', d.getAttribute('data-up') || '');
      }
      d.textContent = 'Incluido';
      d.removeAttribute('data-up');
    } else if (d.getAttribute('data-sl-orig') !== null) {
      d.textContent = d.getAttribute('data-sl-orig');
      if (d.getAttribute('data-sl-origup')) {
        d.setAttribute('data-up', d.getAttribute('data-sl-origup'));
      }
      d.removeAttribute('data-sl-orig');
      d.removeAttribute('data-sl-origup');
    }
  }

  function revisar() {
    if (ocupado) return;
    ocupado = true;
    try {
      Array.prototype.forEach.call(cajas(), function (caja) {
        var lista = botonesHoja(caja);
        if (!lista.length) return;

        var neo = esNeopixel(sistemaElegido(caja));
        var visibles = [];
        var hayElegida = false;

        lista.forEach(function (b) {
          var v = limpio(b.getAttribute('data-sl-val'));
          var ok = neo ? v === 'neoblade' : v !== 'neoblade';
          b.classList.toggle('sl-hoja-off', !ok);
          if (ok) {
            visibles.push(b);
            if (b.getAttribute('aria-pressed') === 'true') hayElegida = true;
          }
          if (v === 'neoblade') importe(b, neo);
        });

        if (!hayElegida && visibles.length) {
          ocupado = false;
          visibles[0].click();
        }
      });
    } catch (e) {
      /* nunca romper la ficha de producto por esto */
    }
    ocupado = false;
  }

  function pronto() {
    setTimeout(revisar, 0);
    setTimeout(revisar, 250);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-sl-opt]')) pronto();
  });

  function arrancar() {
    estilos();
    revisar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El editor de temas vuelve a pintar secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', function () {
    estilos();
    pronto();
  });
})();
